<div class="wrapper">
  <div class="header">
    <form (submit)="preventDefault($event)">
      <input type="text" placeholder="Zoeken..." [formControl]="search">
      <i class="fa-solid fa-xmark close-icon" (click)="closeDialog()"></i>
    </form>
  </div>


  <h2>Gevonden items</h2>
  <p *ngIf="search.value === '' || search.value === null">Type een zoekwoord in de zoekbalk</p>
  <p *ngIf="search.value !== '' && search.value !== null && filteredBlocks.length === 0 && emptyResults === false">Aan het zoeken...</p>
  <p *ngIf="emptyResults && search.value !== '' && search.value !== null">Niks gevonden...</p>
  <div class="block-wrapper">
    <div class="block" *ngFor="let block of filteredBlocks" (click)="goToBlock(block.displayId)">
      <div class="time-wrapper" *ngIf="(block.dates ?? []).length === 1">
        <p class="begin-date">{{ block.beginDate }}</p>
        <p class="period">Periode {{ block.period }}</p>
      </div>
      <div class="title" *ngIf="(block.coverText?.document ?? []).length > 0" [appHighlight]="highlightedSearch">
        {{ block.coverText?.document?.[0]?.children?.[0]?.text }}
      </div>
      <div class="paragraphs">
        <div class="matched-sentence" [appHighlight]="highlightedSearch" *ngIf="block.matchedSentence">{{ block.matchedSentence }}</div>

        <ng-container [appHighlight]="highlightedSearch" *ngFor="let paragraph of (block.coverText?.document ?? []).slice(1)">
          <app-document-renderer *ngIf="!block.matchedSentence" [appHighlight]="highlightedSearch" [document]="[paragraph]"></app-document-renderer>
        </ng-container>
      </div>
      <i class="fa-light fa-circle-arrow-right link-icon"></i>
    </div>
  </div>
</div>
